import { ListQueryParam, SchedulingType, UliActivityType } from '../../../../../common/constants';
import { AddressModel, CarrierModel, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { CompartmentSapModel } from './compartment.model';

export interface CompartmentRuleListURIParams {
  hubId: number;
  compartmentId: number;
  searchCriteria?: CompartmentRuleListSearchCriteria;
}

export class CompartmentRuleListItem {
  id: number;
  name: string;
  activityTypes: UliActivityType[];
  dockId: number;
  dockName: string;
  carrier: CarrierModel;
  deliveryAddresses: AddressModel[];
  erp: boolean;
  pickupAddresses: AddressModel[];
  startTime: string;
  endTime: string;
  validFrom: string;
  validTo: string;
  schedulingType: SchedulingType;
  compartmentSapClientViews: CompartmentSapModel[];

  constructor(params?: CompartmentRuleListItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CompartmentRuleListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;
  [ListQueryParam.ActivityType]: UliActivityType;
  [ListQueryParam.HasSapClientViews]: boolean;

  constructor(params?: CompartmentRuleListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
